/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface CooperativeFilterResponse {
  /**
   * Id filtra
   * @format int64
   * @example 1
   */
  filterId: number;
  /**
   * Nazwa filtra
   * @example "Any filter name"
   */
  name: string;
  /**
   * Czas opóźnień powiadomień
   * @format int32
   * @default 0
   * @example 720
   */
  notificationsDelay: number;
  /**
   * Powiadomienia sms
   * @example true
   */
  alertSms?: boolean | null;
  /**
   * Powiadomienia email
   * @example true
   */
  alertEmail?: boolean | null;
  /**
   * Powiadomienia push
   * @example true
   */
  alertPush?: boolean | null;
  /** Lokalizacje */
  locations?: LocationDto[];
  /** Lokalizacje OSM */
  filterLocations?: OsmLocationDto[];
  /**
   * Pożądane słowa kluczowe
   * @example ["XYZ","YXZ","YZX"]
   */
  wantedKeywords?: (string | null)[];
  /**
   * Niepożądane słowa kluczowe
   * @example ["XYZ","YXZ","YZX"]
   */
  unwantedKeywords?: (string | null)[];
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @min 1
   * @example 3
   */
  daysAmount?: number | null;
  /**
   * Data dodania od
   * @format date
   * @example "2024-01-01"
   */
  dateAddedFrom?: string | null;
  /**
   * Data dodania do
   * @format date
   * @example "2024-01-04"
   */
  dateAddedTo?: string | null;
  /**
   * Moduł
   * @default "COOPERATIVE"
   */
  module: string;
}

/** Lokalizacja */
export interface LocationDto {
  /**
   * Id lokalizacji
   * @format int32
   */
  id?: number;
  /** Pełna lokalizacja */
  fullName?: string;
}

/** Lokalizacja */
export interface OsmLocationDto {
  /**
   * Id lokalizacji
   * @format int32
   */
  id?: number;
  /** Pełna lokalizacja */
  fullName?: string;
}

export interface ScrapedPortalsRequest {
  /** Lokalizacje */
  locations: LocationDto[];
  /** Lokalizacje OSM */
  filterLocations: OsmLocationDto[];
}

export interface UserPortalRequest {
  /**
   * Link do portalu
   * @example "bip gniezno"
   */
  link: string;
}

export interface CooperativeFilterCreateRequest {
  /**
   * Nazwa filtra
   * @example "Any filter name"
   */
  name: string;
  /**
   * Czas opóźnień powiadomień
   * @format int32
   * @default 0
   * @example 720
   */
  notificationsDelay: number;
  /**
   * Powiadomienia sms
   * @example true
   */
  alertSms?: boolean | null;
  /**
   * Powiadomienia email
   * @example true
   */
  alertEmail?: boolean | null;
  /**
   * Powiadomienia push
   * @example true
   */
  alertPush?: boolean | null;
  /** Lokalizacje */
  locations?: LocationDto[];
  /** Lokalizacje OSM */
  filterLocations?: OsmLocationDto[];
  /**
   * Pożądane słowa kluczowe
   * @example ["XYZ","YXZ","YZX"]
   */
  wantedKeywords?: (string | null)[];
  /**
   * Niepożądane słowa kluczowe
   * @example ["XYZ","YXZ","YZX"]
   */
  unwantedKeywords?: (string | null)[];
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @min 1
   * @example 3
   */
  daysAmount?: number | null;
  /**
   * Data dodania od
   * @format date
   * @example "2024-01-01"
   */
  dateAddedFrom?: string | null;
  /**
   * Data dodania do
   * @format date
   * @example "2024-01-04"
   */
  dateAddedTo?: string | null;
}

export interface CooperativeSearchingRequest {
  /**
   * Domyślnie Sortowanie
   * Do wyboru DATE_DESC oraz DATE_ASC
   */
  sortType?: CooperativeSearchingRequestSortTypeEnum;
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @example 3
   */
  daysAmount?: number | null;
  /**
   * Data dodania od
   * @format date
   * @example "2024-01-01"
   */
  dateAddedFrom?: string | null;
  /**
   * Data dodania do
   * @format date
   * @example "2024-01-01"
   */
  dateAddedTo?: string | null;
  /**
   * Niepożądane słowa kluczowe
   * @example ["XYZ","YXZ","YZX"]
   */
  unwantedKeywords?: (string | null)[];
  /**
   * Pożądane słowa kluczowe
   * @example ["XYZ","YXZ","YZX"]
   */
  wantedKeywords?: (string | null)[];
  /** Lokalizacje */
  locations?: LocationDto[];
  /** Lokalizacje OSM */
  filterLocations?: OsmLocationDto[];
  /** Pokazywanie odblokowanych ogłoszeń */
  unlockedAdvertisements?: boolean;
}

export interface Page {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  pageable?: PageableObject;
  last?: boolean;
  /** @format int32 */
  size?: number;
  content?: object[];
  /** @format int32 */
  number?: number;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  first?: boolean;
  empty?: boolean;
}

export interface PageableObject {
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int64 */
  offset?: number;
  sort?: SortObject;
  paged?: boolean;
  unpaged?: boolean;
}

export interface SortObject {
  sorted?: boolean;
  empty?: boolean;
  unsorted?: boolean;
}

export interface CooperativeBlockageResponse {
  /**
   * Id oryginalnego ogłoszenia zablokowanego
   * Id oryginalnego ogłoszenia mogą się zmienić podczas działania aplikacji
   * @format int64
   * @example 1
   */
  originalAdvertisementId: number;
  /**
   * Czas blokady w dniach
   * @format int32
   * @example 14
   */
  days: number;
  /**
   * Data blokady
   * @format date-time
   */
  blockedDate: string;
  /**
   * Nazwa użytkownika blokującego ogłoszenie
   * @example "Jan Kowalski"
   */
  userName: string;
  /**
   * Czy blokada jest stała
   * @example true
   */
  permanentlyBlocked: boolean;
}

export interface CooperativeResponse {
  /**
   * Id ogłoszenia
   * @format int64
   */
  cooperativeId: number;
  /** Id ogłoszenia */
  encryptedId: string;
  /**
   * Moduł
   * @example "COOPERATIVE"
   */
  module: string;
  /**
   * Lokalizacja
   * @example "Wielkopolskie, Leszczyński, Święciechowa, Ul. Leszczyńska"
   */
  location: string;
  /**
   * Liczba notatek
   * @format int32
   * @example 2
   */
  numberOfNotes: number;
  newestNote?: NoteResponse;
  reaction?: ReactionResponse;
  /**
   * Link do ogłoszenia
   * @example "https://komunikaty.pl/link"
   */
  link: string;
  /**
   * Tytuł ogłoszenia
   * @example "Tytuł"
   */
  title: string;
  /**
   * Data dodania ogłoszenia
   * @example "17.12.2027, 09:53"
   */
  dateAdded: string;
  /**
   * Nazwa portalu
   * @example "Licytacje Komornik"
   */
  portal: string;
  blockage?: CooperativeBlockageResponse;
}

/**
 * Notatki
 * @example {"noteId":null,"content":"Dowolny opis","date":"2024-08-22T07:34:12.770Z"}
 */
export interface NoteResponse {
  /**
   * Id notatki
   * @format int64
   * @example 1
   */
  noteId: number;
  /**
   * Treść notatki
   * @example "Dowolna treść"
   */
  content: string;
  /**
   * Data dodania notatki
   * @format date-time
   */
  date: string;
}

/**
 * Reakcja
 * @example {"likeStatus":true,"unlikeStatus":false,"viewedStatus":false,"outdatedStatus":false,"arrangedStatus":false,"phoneStatus":false,"hideStatus":false,"openedStatus":false}
 */
export interface ReactionResponse {
  /**
   * Status 'lubię'
   * @example true
   */
  likeStatus?: boolean;
  /**
   * Status 'nie lubię'
   * @example true
   */
  unlikeStatus?: boolean;
  /**
   * Status 'obejrzane'
   * @example true
   */
  viewedStatus?: boolean;
  /**
   * Status 'nieaktualne'
   * @example true
   */
  outdatedStatus?: boolean;
  /**
   * Status 'spotkania'
   * @example true
   */
  arrangedStatus?: boolean;
  /**
   * Status 'telefonu'
   * @example true
   */
  phoneStatus?: boolean;
  /**
   * Status 'ukrycia
   * @example true
   */
  hideStatus?: boolean;
  /**
   * Status 'otwarte'
   * @example true
   */
  openedStatus?: boolean;
}

export interface CooperativeDetailsResponse {
  /**
   * Id ogłoszenia
   * @format int64
   * @example 1
   */
  cooperativeId: number;
  /** Id ogłoszenia */
  encryptedId: string;
  /**
   * Tytuł ogłoszenia
   * @example "Tytuł"
   */
  title: string;
  /**
   * Lokalizacja
   * @example "Wielkopolskie, Leszczyński, Święciechowa, Ul. Leszczyńska"
   */
  location: string;
  /**
   * Data dodania ogłoszenia
   * @example "17.12.2027, 09:53"
   */
  dateAdded: string;
  /**
   * Link do ogłoszenia
   * @example "https://komunikaty.pl/link"
   */
  link: string;
  /**
   * Opis
   * @example "Dowolny opis"
   */
  description?: string;
  reaction?: ReactionResponse;
  /**
   * Notatki
   * @example {"noteId":null,"content":"Dowolny opis","date":"2024-08-22T07:34:12.770Z"}
   */
  notes?: NoteResponse[];
  /**
   * Portal
   * @example "SM Gniezno"
   */
  portalName: string;
}

export interface CooperativeFilterListResponse {
  /**
   * Id filtra
   * @format int64
   * @example 1
   */
  filterId: number;
  /** Nazwa filtra */
  name: string;
  /**
   * Powiadomienia sms
   * @example true
   */
  alertSms: boolean;
  /**
   * Powiadomienia email
   * @example true
   */
  alertEmail: boolean;
  /**
   * Powiadomienia push
   * @example true
   */
  alertPush: boolean;
}

/**
 * Domyślnie Sortowanie
 * Do wyboru DATE_DESC oraz DATE_ASC
 */
export enum CooperativeSearchingRequestSortTypeEnum {
  DATE_DESC = "DATE_DESC",
  DATE_ASC = "DATE_ASC",
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "http://192.168.31.12:8080";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title OpenAPI definition
 * @version v0
 * @baseUrl http://192.168.31.12:8080
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  v2 = {
    /**
     * No description
     *
     * @tags cooperative-filter-controller
     * @name EditFilter
     * @summary Edycja filtra
     * @request PUT:/v2/cooperative-offer/filter/edit
     * @secure
     */
    editFilter: (data: CooperativeFilterResponse, params: RequestParams = {}) =>
      this.http.request<object, void>({
        path: `/v2/cooperative-offer/filter/edit`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags cooperative-controller
     * @name FindScrapedPortalsByLocation
     * @summary Pobieranie listy monitorowanych portali według lokalizacji
     * @request POST:/v2/cooperative-offer/portal/list
     * @secure
     */
    findScrapedPortalsByLocation: (data: ScrapedPortalsRequest, params: RequestParams = {}) =>
      this.http.request<string, any>({
        path: `/v2/cooperative-offer/portal/list`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags cooperative-controller
     * @name AddUserPortal
     * @summary Wysyłanie prośby użytkownika o dodanie nowego portalu
     * @request POST:/v2/cooperative-offer/portal/add
     * @secure
     */
    addUserPortal: (data: UserPortalRequest, params: RequestParams = {}) =>
      this.http.request<object, any>({
        path: `/v2/cooperative-offer/portal/add`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags cooperative-filter-controller
     * @name CreateFilter
     * @summary Tworzenie nowego filtra
     * @request POST:/v2/cooperative-offer/filter/create
     * @secure
     */
    createFilter: (data: CooperativeFilterCreateRequest, params: RequestParams = {}) =>
      this.http.request<number, void>({
        path: `/v2/cooperative-offer/filter/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags cooperative-controller
     * @name FindCooperatives
     * @summary Pobieranie listy ogłoszeń
     * @request POST:/v2/cooperative-offer/advertisement
     * @secure
     */
    findCooperatives: (
      query: {
        /** @format int32 */
        page: number;
        /** @format int32 */
        size: number;
      },
      data: CooperativeSearchingRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<CooperativeResponse, any>({
        path: `/v2/cooperative-offer/advertisement`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags cooperative-controller
     * @name GetCooperativeDetailsByEncryptedId
     * @summary Pobieranie szczegołów podanego ogłoszenia według zakodowanego Id
     * @request GET:/v2/cooperative-offer/single-advertisement/detail
     * @secure
     */
    getCooperativeDetailsByEncryptedId: (
      query: {
        hash: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<CooperativeDetailsResponse, any>({
        path: `/v2/cooperative-offer/single-advertisement/detail`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags cooperative-filter-controller
     * @name FindUserFilters
     * @summary Pobieranie listy filtrów użytkownika (Bez szczegółów)
     * @request GET:/v2/cooperative-offer/filter/list
     * @secure
     */
    findUserFilters: (params: RequestParams = {}) =>
      this.http.request<CooperativeFilterListResponse, any>({
        path: `/v2/cooperative-offer/filter/list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags cooperative-filter-controller
     * @name GetFilterDetails
     * @summary Pobieranie wszystkie szczegóły poszczególnego filtra
     * @request GET:/v2/cooperative-offer/filter/details
     * @secure
     */
    getFilterDetails: (
      query: {
        /**
         * Id filtra
         * @format int64
         */
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<CooperativeFilterResponse, string>({
        path: `/v2/cooperative-offer/filter/details`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags cooperative-controller
     * @name GetCooperativeDetailsById
     * @summary Pobieranie szczegołów podanego ogłoszenia według zwykłego Id
     * @request GET:/v2/cooperative-offer/advertisement/details
     * @secure
     */
    getCooperativeDetailsById: (
      query: {
        /** @format int64 */
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<CooperativeDetailsResponse, any>({
        path: `/v2/cooperative-offer/advertisement/details`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags cooperative-filter-controller
     * @name DeleteFilter
     * @summary Usuwanie filtra
     * @request DELETE:/v2/cooperative-offer/filter/delete
     * @secure
     */
    deleteFilter: (
      query: {
        /**
         * Id filtra
         * @format int64
         */
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<object, void>({
        path: `/v2/cooperative-offer/filter/delete`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),
  };
}
